<template>
  <div data-v-a403a32a class="Panel">
    <div data-v-a403a32a="" class="tip"><span data-v-a403a32a="">绮罗纤缕见肌肤，此时还恨薄情无。</span></div>
    <div data-v-a403a32a="" class="el-card P-Login is-never-shadow">
      <div class="el-card__body">
        <div data-v-a403a32a="" class="G-Title"><i data-v-a403a32a="" class="el-icon-user-solid"></i><span
            data-v-a403a32a="">用户登录</span></div>
        <div data-v-a403a32a="">
          <form :model="loginform" data-v-a403a32a="" class="el-form AuthForm">
            <div data-v-a403a32a="" class="el-form-item form-group el-form-item--feedback">
              <div class="el-form-item__content">
                <div data-v-a403a32a="" class="el-input"><input type="username" @keyup.enter="loginform_submit" v-model="loginform.username" autocomplete="off"
                    placeholder="请输入用户名或邮箱" class="el-input__inner"></div>
              </div>
            </div>
            <div data-v-a403a32a="" class="el-form-item el-form-item--feedback" style="padding-bottom: 4px;">
              <div class="el-form-item__content">
                <div data-v-a403a32a="" class="el-input"><input type="password" @keyup.enter="loginform_submit" v-model="loginform.password" autocomplete="off" placeholder="请输入密码"
                    class="el-input__inner"></div>
              </div>
            </div>
            <div data-v-a403a32a="" class="el-form-item el-form-item--feedback">
              <div class="el-form-item__content">
                <div data-v-a403a32a="" style="text-align: right;"><a data-v-a403a32a="" href="/forget"
                    class="link">忘记密码？</a></div> <button @click="loginform_submit" data-v-a403a32a="" type="button"
                  class="el-button el-button--primary" style="width: 100%; margin-top: 4px;"><span>登录
                  </span></button>
              </div>
            </div>
          </form>
        </div>
        <div data-v-a403a32a="" class="my-3">您还不是一楼一凤会员？</div> <a data-v-a403a32a="" href="/registered"
          class="link"><button data-v-a403a32a="" type="button" class="el-button el-button--default is-plain is-round"
            style="margin-bottom: 10px;"><span>立即注册</span></button></a>
      </div>
    </div>
  </div>
</template>

<script>
import cookie from 'js-cookie'
export default {
  name: 'login',
  data() {
    return {

      loginform:{
        username:'',
        password:'',
      }

    }
  },
  methods:{
    loginform_submit(){

      let username = this.loginform.username
      let password = this.loginform.password
      if(username){
        if(password){

          this.$http.post('/api/login',{username:username,password:password}).then(res=>{

            if(res.data.code===0){

              this.$message({
                message: res.data.msg,
                type: 'error'
              });

            }else if(res.data.code===1){

              cookie.set('sessionid',res.data.sessionid)

              this.$message({
                message: '登录成功',
                type: 'success',
                onClose:()=>{
                    window.location.href='usercenter';
                }
              });

            }

          })

        }else{
          this.$message({
            message: '请输入密码',
            type: 'error'
          });
        }
      }else{

        this.$message({
          message: '请输入用户名',
          type: 'error'
        });

      }

    }
  },
  mounted() {

    let sessionid = cookie.get('sessionid')
    if(sessionid){

      window.location.href = '/usercenter'
      
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>


// WEBPACK FOOTER //
// src/components/Login.vue